import React from 'react';
import {
    ClientStatusContextValue,
    ClientStatusProviderProps,
    ClientStatus,
} from '../types/clientStatus';
import { useClientStatus } from '../hooks/useClientStatus';

const defaultClientStatus: ClientStatus = {
    isBankAccountConnected: false,
    isEmailConnected: false,
    hasHubSetup: false,
};

const defaultClientStatusContextValue: ClientStatusContextValue = {
    status: defaultClientStatus,
    updateStatus: () => Promise.resolve(),
    isOnboardingTasksCompleted: false,
    terms: {
        clientTerms: undefined,
        needsToAcceptTerms: undefined,
        acceptTerms: () => Promise.resolve(),
        declineTerms: () => Promise.resolve(),
    },
    hubs: [],
    getClientOnboardingStatus: () => Promise.resolve(),
};

const ClientStatusContext = React.createContext<ClientStatusContextValue>(
    defaultClientStatusContextValue,
);

const ClientStatusProvider: React.FC<ClientStatusProviderProps> = ({ children }) => {
    const {
        status,
        updateStatus,
        isOnboardingTasksCompleted,
        acceptTerms,
        needsToAcceptTerms,
        hubs,
        declineTerms,
        clientTerms,
        getClientOnboardingStatus,
    } = useClientStatus(defaultClientStatus);

    const value = React.useMemo(
        () => ({
            status,
            isOnboardingTasksCompleted,
            updateStatus,
            terms: {
                needsToAcceptTerms,
                acceptTerms,
                declineTerms,
                clientTerms,
            },
            hubs,
            getClientOnboardingStatus,
        }),
        [
            status,
            isOnboardingTasksCompleted,
            updateStatus,
            acceptTerms,
            needsToAcceptTerms,
            hubs,
            declineTerms,
            clientTerms,
            getClientOnboardingStatus,
        ],
    );

    return <ClientStatusContext.Provider value={value}>{children}</ClientStatusContext.Provider>;
};

export { ClientStatusContext, ClientStatusProvider };
